module.exports = __webpack_public_path__ + "img/header.5fc109a8.png";